const FILTERS = [
  { id: "none", label: "None" },
  { id: "grayscale", label: "Grayscale" },
  { id: "sepia", label: "Sepia" },
  { id: "contrast", label: "High Contrast" },
  { id: "warm", label: "Warm" },
  { id: "cool", label: "Cool" },
  { id: "vintage", label: "Vintage" },
];
const FILTER_STYLES = {
  none: "none",
  grayscale: "grayscale(1)",
  sepia: "sepia(1)",
  contrast: "contrast(1.4)",
  warm: "brightness(1.05) saturate(1.3)",
  cool: "brightness(0.95) saturate(0.9) hue-rotate(180deg)",
  vintage: "sepia(0.6) contrast(1.2) saturate(0.8)",
};


export default function FilterPanel({
  slideIndex,
  filters,
  setFilters,
  previewSrc,
}) {
  const active = filters[slideIndex] || "none";

  return (
  <div
    className="
      p-4 space-y-4
      text-gray-900 dark:text-gray-100
    "
  >
    {/* Title */}
    <h3 className="text-sm font-semibold text-gray-700 dark:text-gray-300">
      Filters – Slide {slideIndex}
    </h3>

    {/* Filters grid */}
    <div className="grid grid-cols-2 gap-3">
      {FILTERS.map((f) => {
        const isActive = active === f.id;

        return (
          <button
            key={f.id}
            onClick={() =>
              setFilters((prev) => ({
                ...prev,
                [slideIndex]: f.id,
              }))
            }
            className={`
              rounded-lg overflow-hidden text-left transition
              bg-white dark:bg-gray-900
              border
              ${
                isActive
                  ? "border-blue-500 ring-2 ring-blue-500"
                  : "border-gray-300 dark:border-gray-700 hover:border-gray-400 dark:hover:border-gray-500"
              }
            `}
          >
            {/* ───────── Preview ───────── */}
            <div
              className="
                h-20 overflow-hidden
                bg-black
                border-b border-gray-200 dark:border-gray-700
              "
            >
              {previewSrc ? (
                <img
                  src={previewSrc}
                  alt={f.label}
                  className="w-full h-full object-cover"
                  style={{ filter: FILTER_STYLES[f.id] }}
                />
              ) : (
                <div className="w-full h-full bg-gray-200 dark:bg-gray-800" />
              )}
            </div>

            {/* ───────── Label ───────── */}
              <div
                className={`
                  text-xs px-2 py-1 text-center
                  font-medium
                  ${
                    isActive
                      ? "text-blue-700 dark:text-blue-400"
                      : "text-gray-900 dark:text-gray-300"
                  }
                `}
              >
                {f.label}
              </div>

          </button>
        );
      })}
    </div>
  </div>
);

}
